module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-kaoawase-venue-07f81334b7d44fa641cc767155cfe655.png";